export default __webpack_public_path__ + "static/media/flood_final1.c6f0e6c8.jpg";